import React from 'react';
import image1 from '../../../../../images/modules/module-1/17.png';
import image2 from '../../../../../images/modules/module-1/18.png';
import image3 from '../../../../../images/modules/module-1/19.png';
import './index.scss';

export const BottomSectionContent = () => {
    return (
        <div className='revue-bottom'>
            <div className='revue-bottom__main-image'>
                <img src={image1} alt='fashion' />
            </div>
            <div className='revue-bottom__content'>
                <div className='revue-bottom__category'>Events</div>
                <div className='revue-bottom__title'>Latest in Tokyo Fall 2025</div>
                <div className='revue-bottom__text'>
                    Take a walk around Omotesando early on a weekday morning and you’ll spot them. Dressed in their
                    unmistakable finery—pouffy skirts, pearl-buttoned suits, and chunky sneakers—they slowly converge in
                    the streets, totally distinct from the drearily dressed salarymen and women also on their way to
                    work. The destination of these unique but uniformly stylish disciples is the same: the Comme des
                    Garçons office in Aoyama. This is the comme-ute...
                </div>
                <div className='revue-bottom__button'>
                    <button>READ FULL ARTICLE</button>
                </div>
            </div>
            <div className='revue-bottom__secondary-image-1'>
                <img src={image2} alt='fashion' />
            </div>
            <div className='revue-bottom__secondary-image-2'>
                <img src={image3} alt='fashion' />
            </div>
        </div>
    );
};
